define(["require", "exports", "./Contracts/Contracts", "./Contracts/KubeServiceBase", "./WebUI/Common/KubeSummary"], function (require, exports, Contracts_1, KubeServiceBase_1, KubeSummary_1) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    __export(Contracts_1);
    __export(KubeServiceBase_1);
    __export(KubeSummary_1);
});
